export enum NavigationLinks {
	shopify = 'https://new-hope-network.myshopify.com/checkouts/co/fc14231aff9d0882e37527c3bddb90a6',
	beaconDiscovery = 'https://beaconapp.newhope.com/',
	howGood = 'https://www.howgood.com/beacon-sustainability-data-portal',
	marketVerified = 'https://marketreadyinsights.com/marketready-verified/',
	beaconStandard = 'https://standards.newhope.com/',
	beaconFAQ = '/beaconFAQ'
}

export enum SubscriptionModel {
	heading = 'Basic Subscription',
	subHeading = 'Beacon Discovery: Non-Exhibiting Brand Basic Subscription'
}

export const BeaconContent = {
	link: 'Beacon Discovery',
	content: ` is the anytime-anywhere discovery and engagement platform for natural products brands and
				retailers. Beacon Discovery lets brands easily share more product information with key
				decision makers, to show products in their best and most transparent light. Top retail
				buyers, investors, brokers, marketing agencies, and more are looking for new products and
				brands on Beacon Discovery.`
};

export const PartnerContent = {
	heading: 'Our Partners',
	content: {
		firstContent: ` Using the hundreds of SPINS filters, retail buyers and investors can find the perfect
                product they've been looking for - your product! Plus, each product uploaded gets assessed
                for a free sustainability impact estimate from our partner `,
		secondContent: `. This highlights brands who are making ESG-minded efforts and helps them stand out to
                retailers with similar values. Go one step further and get a`,
		thirdContent: ` badge, a new distinction that elevates the integrity of the products and businesses within
                the natural product market.`
	},
	links: {
		howGood: 'HowGood',
		marketVerified: 'MarketReady Verified'
	}
};

export const SubscriptionContent = {
	heading: 'Subscription Details',
	content: {
		firstContent: `The base Beacon Discovery subscription includes unlimited product uploads in 2025. Your
                subscription will be active for one year from the date of purchase.  Please note,
                application does not guarantee product placement on Beacon Discovery. Products must meet our
                New Hope standards to be eligible for the platform. To learn more about our Ingredient and
                Labeling Standards, click `
	},
	links: {
		here: `here.`
	}
};

export const QuestionsContent = {
	heading: `Questions?`,
	content: {
		firstContent: `For questions about the Beacon Discovery onboarding process, contact us at `,
		secondContent: `. For Standards questions, contact our Standards Specialists at `
	},
	links: {
		audienceSuccess: {
			content: `AudienceSuccessTeam@NewHope.com`,
			link: `mailto:AudienceSuccessTeam@NewHope.com`
		},
		standards: {
			content: `Standards@NewHope.com.`,
			link: `mailto:Standards@NewHope.com`
		}
	}
};
